<template>
    <div>
        <div class="d-flex justify-content-between text-right pt-4">
            <div>
                <b-btn v-show="register_step === 1"
                       variant="outline-secondary"
                       :disabled="register_loading"
                       class="mr-2"
                       :to="{ name: 'Login' }"
                >
                    {{ $t(`돌아가기`) }}
                </b-btn>
                <b-btn v-show="register_step > 1 && register_step < 3"
                       variant="secondary"
                       :disabled="register_loading"
                       class="mr-2"
                       @click="goBeforeStep"
                >
                    {{ $t(`뒤로가기`) }}
                </b-btn>
                <b-btn variant="warning"
                       :disabled="register_loading"
                       @click="openInquiryModal"
                >
                    {{ $t(`문의하기`) }}
                </b-btn>
            </div>

            <div class="ml-auto">
                <slot></slot>
            </div>
        </div>
        <InquiryToQesg ref="InquiryToQesg"/>
    </div>
</template>

<script>
import InquiryToQesg from '@/components/auth/Register/_SubComponents/InquiryToQesg.vue';
import {mapActions, mapState} from 'vuex';

export default {
    name: 'CommonRegisterFooter',
    components: {InquiryToQesg},
    data() {
        return {};
    },
    computed: {
        ...mapState('register', ['register_step', 'register_loading'])
    },
    methods: {
        ...mapActions('register', ['setRegisterStep']),
        goBeforeStep() {
            this.setRegisterStep(this.register_step - 1);
        },
        openInquiryModal() {
            this.$refs.InquiryToQesg.openModal();
        }
    },


};
</script>

<style lang="scss" scoped>

</style>
